<template>
  <validation-observer tag="div" class="container container-fluid mt-4 mb-4" @submit.native.prevent ref="validation">
    <div class="card card-xs-full">
      <div class="card-body" @submit.prevent>
        <div class="row">
          <div class="col-lg mb-4 mb-lg-0">
            <div v-if="screen.thumbnail || googleMapsEmbedUrl" class="screen-preview-stack">
              <img
                v-if="screen.thumbnail"
                v-bind:src="screen.thumbnail"
                alt="screen preview"
                class="screen-thumbnail-lg screen-preview-image"
              >

              <div
                v-if="googleMapsEmbedUrl"
                class="screen-location-map-card"
              >
                <iframe
                  :src="googleMapsEmbedUrl"
                  title="Screen location map"
                  class="screen-location-map-frame"
                  loading="lazy"
                  allowfullscreen
                />
              </div>

            </div>
          </div>
          <div class="col-lg">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h3 class="mb-0">Details</h3>
              <span v-if="!isManual" :class="statusTextClass()">
                <i class="far fa-fw" :class="statusIndicatorClass()"></i>
                {{ statusText() }}
              </span>
            </div>

            <div class="mb-3">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center" style="width: 40px;"></div>
                <div class="col">
                  <template v-if="isManual">
                    <validation-provider name="name" vid="name" rules="required">
                      <label class="form-label">Name</label>
                      <c-input type="text" v-model="manualName" />
                      <c-help-block />
                    </validation-provider>
                  </template>
                  <template v-else>
                    <p class="form-label">Name</p>
                    <p class="text-muted mb-0">{{ screen.name }}</p>
                  </template>
                </div>
              </div>
            </div>

            <div class="mb-3" v-if="$isA('admin')">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-sun"></i></div>

                <div class="col">
                  <p class="form-label">Max Brightness (cd/m<sup> 2 </sup>) </p>
                  <c-input type="number" v-model="screenMaxBrightness"/>
                </div>
              </div>
            </div>

            <div class="mb-3" v-if="!isManual">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-sun"></i></div>

                <div class="col">
                  <div class="row">

                    <div class="col-auto">
                      <p class="form-label">Current Brightness</p>
                      <p class="text-muted mb-0">{{ screen.brightness_percentage === '-' ? '-' : screen.brightness_percentage+'%' }}</p>
                    </div>

                    <div v-if="$isA('admin')" class="col-auto">
                      <p class="form-label">Ambient Brightness</p>
                      <p class="text-muted mb-0">{{ screen.environment_brightness }}</p>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <div v-if="$isA('admin') && !isManual" class="mb-3">
              <div class="row align-items-center">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-wrench"></i></div>

                <div class="col row row-cols-2 row-cols-xl-3 align-items-end gx-3">
                  <div class="col">
                    <p class="form-label">Qty Total PSU</p>
                    <c-input type="number" v-model="screenTotalPsu"/>
                  </div>
                  <div class="col">
                    <p class="form-label">Qty Total Receiving Card</p>
                    <c-input type="number" v-model="screenTotalReceivingCard"/>
                  </div>
                  <div class="col mt-3 mt-xl-0">
                    <p class="form-label">Qty Total Module</p>
                    <c-input type="number" v-model="stateTotalQtyModule"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-map"></i></div>
                <div class="col">
                  <div v-if="!isManual">
                    <p class="form-label">Address</p>
                    <p class="text-muted mb-0">{{ screen.address }}</p>
                  </div>
                  <validation-provider v-else name="address" vid="address" rules="required" class="d-block">
                    <label class="form-label">Address</label>
                    <c-input type="text" v-model="manualAddress" />
                    <c-help-block />
                  </validation-provider>
                </div>
              </div>
            </div>

            <!-- removed as per ticket 43826 -->
            <!-- Values getting pulled from iCare are incorrect, so we're not showing it -->
            <!-- Left here incase it gets sorted and we decide to display again -->
            <!-- <div class="mb-3">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-map-marker-alt"></i></div>

                <div class="col">
                  <p class="form-label">Location</p>
                  <template v-if="isManual">
                    <c-input type="text" v-model="locationInput" placeholder="-123.123, 456.456" />
                    <small class="text-muted mt-2 d-block">
                      Enter Latitude and Longitude (e.g. -123.123, 456.456)
                    </small>
                  </template>
                  <p v-else class="text-muted mb-0">{{ screen.latitude }}, {{ screen.longitude }}</p>
                </div>
              </div>
            </div> -->

            <div class="mb-3">
              <div class="row gx-3" v-if="$isA('admin')">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-bolt"></i></div>

                <div class="col">
                  <p class="form-label">Energy Provider</p>
                  <energy-provider-select v-model="stateEnergyProvider"/>
                </div>
              </div>

              <div class="row gx-3 mt-3" v-if="stateEnergyProvider">
                <div class="col-auto d-flex align-items-center" v-if="$isA('admin')" style="width: 40px"></div>
                <div class="col-auto d-flex align-items-center" v-else><i class="far fa-fw fa-lg fa-bolt"></i></div>
                <div class="col">
                  <p class="form-label">Energy Provider</p>
                  <p class="text-muted">
                    {{ stateEnergyProvider.name }}
                  </p>
                </div>
                <div class="col">
                  <p class="form-label">Provider Website</p>
                  <a :href="stateEnergyProvider.url" target="_blank" class="link-info text-decoration-underline">
                    Outages - {{ stateEnergyProvider.name }}
                  </a>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center" style="width: 40px"></div>

                <div class="col">
                  <validation-provider name="nmi" vid="nmi" v-if="$isA('admin')">
                    <label class="form-label">NMI</label>
                    <c-input type="text" v-model="stateNmi" />
                    <c-help-block />
                  </validation-provider>
                  <template v-else>
                    <p class="form-label">NMI</p>
                    {{ stateNmi || '-' }}
                  </template>
                </div>
              </div>
            </div>

            <div class="mb-3" v-if="$isA('admin')">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-tags"></i></div>
                <div class="col">
                  <p class="form-label">Admin Tags</p>

                  <screen-tag-select holder="All" v-model="stateTags"/>

                </div>
              </div>
            </div>

            <div class="mb-3" v-if="$can('write screens') && !$isA('admin')">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-tags"></i></div>
                <div class="col">
                  <p class="form-label">Tags</p>

                  <media-owner-screen-tag-select holder="All" :mediaOwnerScreenTags="screenMediaOwnerScreenTagOptions" v-model="stateMediaOwnerScreenTags"/>

                </div>
              </div>
            </div>

            <div class="mb-3" v-if="$isA('admin')">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-city"></i></div>
                <div class="col">
                  <p class="form-label">Media Owners</p>
                  <media-owner-select v-model="stateMediaOwnerIds" :multiple="true"/>
                </div>
              </div>
            </div>
            <div class="mb-3" v-if="$isA('admin')">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center" style="width: 40px;"></div>
                <validation-provider
                  tag="div"
                  name="panel_id"
                  vid="panel_id"
                  class="col"
                  :rules="{ required: false }"
                >
                  <p class="form-label">Panel ID (for Seedooh integration only)</p>
                  <c-input type="text" v-model="statePanelId"/>
                  <c-help-block />
                </validation-provider>
              </div>
            </div>
            <div class="mb-3" v-if="$isA('admin') && !isManual">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="fas fa-sharp fa-regular fa-plug"></i></div>
                <div class="col">
                  <c-checkbox v-model="stateHasBackupPowerSupplies">Has backup power supplies</c-checkbox>
                </div>
              </div>
            </div>

            <div class="mb-3" v-if="!isManual">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-power-off"></i></div>
                <div class="col">
                  <p class="form-label">Screen Operating Hours</p>
                    <div v-if="$isA('admin')" class="row gx-3 align-items-end">
                      <div class="col-lg mb-3">
                        <label>Time From</label>
                        <flatpickr v-model="screenStartTime" :config="timeConfig" data-field="timeFrom" class="form-control time-single" />
                      </div>
                      <div class="col-lg mb-3">
                        <label>Time To</label>
                        <flatpickr v-model="screenEndTime" :config="timeConfig" data-field="timeTo" class="form-control time-single" />
                      </div>
                      <div class="col-lg-auto mb-3 d-flex">
                        <button type="button" class="btn btn-outline-secondary px-3" :disabled="!screenStartTime && !screenEndTime" @click="clearOperatingHours">
                          Clear
                        </button>
                      </div>
                    </div>
                    <p v-else-if="screenOperatingHoursText" class="text-muted mb-0">{{ screenOperatingHoursText }}</p>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <validation-provider name="timezone" vid="timezone" rules="required">
                <div class="row gx-3">
                  <div class="col-auto d-flex align-items-center"><i class="far fa-fw fa-lg fa-globe"></i></div>
                  <div class="col">
                    <label class="form-label">Timezone</label>
                    <timezone-select v-model="stateTimezone"/>
                    <c-help-block />
                  </div>
                </div>
              </validation-provider>
            </div>
            <div class="mb-3" v-if="$isA('admin')">
              <validation-provider name="Device ID" vid="device_id">
                <div class="row gx-3">
                  <div class="col-auto d-flex align-items-center" style="width: 40px;">
                    &nbsp;
                  </div>
                  <div class="col">
                    <label class="form-label">Power Consumption - Device ID</label>
                    <c-input type="text" v-model="stateDeviceId"/>
                    <c-help-block />
                  </div>
                </div>
              </validation-provider>
            </div>
          </div>
        </div>
        <hr class="decorative-divider">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-ruler-combined"></i>
                </div>
                <div class="col">
                  <p class="form-label">Screen ID</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="stateScreenId" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-calendar-alt"></i>
                </div>
                <div class="col">
                  <p class="form-label">Install Date</p>
                  <c-input :disabled="!$isA('admin')" type="date" v-model="stateInstallDate" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-ruler-combined"></i>
                </div>
                <div class="col">
                  <p class="form-label">Screen Size</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="stateScreenSize" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-arrows-alt-h"></i>
                </div>
                <div class="col">
                  <p class="form-label">Screen Width</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="stateScreenWidth" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-arrows-alt-v"></i>
                </div>
                <div class="col">
                  <p class="form-label">Screen Height</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="stateScreenHeight" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-desktop"></i>
                </div>
                <div class="col">
                  <p class="form-label">Native Resolution</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="stateNativeResolution" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-expand"></i>
                </div>
                <div class="col">
                  <p class="form-label">Canvas Size</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="stateCanvasSize" />
                </div>
              </div>
            </div>
            </div>
            <div class="col-md-6">
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-th-large"></i>
                </div>
                <div class="col">
                  <p class="form-label">Panel Type</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="statePanelType" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-dot-circle"></i>
                </div>
                <div class="col">
                  <p class="form-label">Pixel Pitch</p>
                  <c-input :disabled="!$isA('admin')" type="text" v-model="statePixelPitch" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-calendar-alt"></i>
                </div>
                <div class="col">
                  <p class="form-label">Parts Warranty Expiration</p>
                  <c-input :disabled="!$isA('admin')" type="date" v-model="statePartsWarrantyExpiration" />
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-wrench"></i>
                </div>
                <div class="col">
                  <p class="form-label">Service Type</p>
                  <select class="form-select" v-model="stateServiceType" :disabled="!$isA('admin')">
                    <option value="Front">Front</option>
                    <option value="Rear">Rear</option>
                    <option value="Both">Both</option>
                    <option value="Unknown">Unknown</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-bolt"></i>
                </div>
                <div class="col">
                  <p class="form-label">PSU Type</p>
                  <select class="form-select" v-model="statePsuType" :disabled="!$isA('admin')">
                    <option value="Normal">Normal</option>
                    <option value="Power Saving">Power Saving</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-2">
              <div class="row gx-3">
                <div class="col-auto d-flex align-items-center">
                  <i class="far fa-fw fa-lg fa-microchip"></i>
                </div>
                <div class="col">
                  <p class="form-label">Diode Type</p>
                  <select class="form-select" v-model="stateDiodeType" :disabled="!$isA('admin')">
                    <option value="Normal">Normal</option>
                    <option value="Power Saving">Power Saving</option>
                    <option value="Ultra Power Saving">Ultra Power Saving</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="$can('write screens')" class="d-flex justify-content-between align-items-center">
          <c-button
            v-if="isManual && !isArchived"
            variant="danger"
            type="button"
            @click="archiveScreen"
          >
            Archive Screen
          </c-button>
          <c-button
            v-if="isArchived"
            variant="warning"
            type="button"
            @click="restoreScreen"
          >
            Restore Screen
          </c-button>
          <c-button type="submit" @click="save" validate class="ms-auto">Save</c-button>
        </div>
      </div>
    </div>
    </validation-observer>
</template>

<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/screens'
import { get, call } from 'vuex-pathify'
import { helperComputed as mediaOwnerHelperComputed, helperMethods as mediaOwnerHelperMethods } from '@/vuex/modules/screens/media-owner-screen-tags'
import { toast } from '@chameleon/chameleon-vue'
import dayjs from 'dayjs'
import MediaOwnerSelect from '@/components/media-owners/MediaOwnerSelect'
import ScreenTagSelect from '@/components/forms/ScreenTagSelect'
import TimezoneSelect from '@/components/forms/TimezoneSelect'
import MediaOwnerScreenTagSelect from '@/components/forms/MediaOwnerScreenTagSelect.vue'
import EnergyProviderSelect from '@/components/forms/EnergyProviderSelect.vue'

export default {
  mixins: [
    stateMapper
  ],

  data () {
    return {
      params: [],
      selectedTags: [],
      statusIndicators: {
        'No Issues': 'fa-check text-success',
        'Communication Error': 'fa-wifi-slash text-warning',
        Offline: 'fa-wifi-slash text-warning',
        Fault: 'fa-exclamation-triangle text-danger'
      },
      selectedMediaOwnerScreenTags: [],
      timeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'h:i K',
        allowInput: false,
        minuteIncrement: 1,
        onChange: (times, timeString, instance) => {
          const field = instance.element.dataset.field
          const formattedTime = dayjs(timeString, 'h:mm A').isValid() ? dayjs(timeString, 'h:mm A').format('HH:mm:ss') : null
          const value = { ...this.user, [field]: formattedTime }

          this.$emit('update', this.index, value)
        }
      },
      manualName: '',
      manualAddress: '',
      locationInput: ''
    }
  },
  components: {
    EnergyProviderSelect,
    MediaOwnerSelect,
    ScreenTagSelect,
    MediaOwnerScreenTagSelect,
    TimezoneSelect
  },
  computed: {
    ...helperComputed,
    ...mediaOwnerHelperComputed,
    ...get('screens', ['screen']),

    isManual () {
      return !!this.screen.is_manual
    },

    isArchived () {
      return !!this.screen.archived
    },

    googleMapsEmbedUrl () {
      const address = this.isManual ? this.manualAddress : this.screen.address

      if (!address) {
        return null
      }

      const query = encodeURIComponent(address)

      return `https://www.google.com/maps?q=${query}&z=15&output=embed`
    },

    screenMediaOwnerScreenTagOptions: {
      get () {
        return this.mediaOwnerScreenTagOptions
      }
    },

    screenMaxBrightness: {
      get () {
        return this.stateMaxBrightness
      },
      set (value) {
        this.stateMaxBrightness = value
      }
    },

    screenTotalPsu: {
      get () {
        return this.stateTotalPsu
      },
      set (value) {
        this.stateTotalPsu = value
      }
    },

    screenTotalReceivingCard: {
      get () {
        return this.stateTotalReceivingCard
      },
      set (value) {
        this.stateTotalReceivingCard = value
      }
    },

    screenStartTime: {
      get () {
        return this.stateStartTime
      },
      set (value) {
        this.stateStartTime = value
      }
    },
    screenEndTime: {
      get () {
        return this.stateEndTime
      },
      set (value) {
        this.stateEndTime = value
      }
    },

    hasPartialOperatingHours () {
      return (!!this.screenStartTime || !!this.screenEndTime) && !(this.screenStartTime && this.screenEndTime)
    },

    screenOperatingHoursText () {
      if (!this.screenStartTime || !this.screenEndTime) {
        return '24 Hours'
      }

      return `${this.screenStartTime} - ${this.screenEndTime}`
    }
  },

  watch: {
    screen: {
      immediate: true,
      handler (value) {
        if (value && value.is_manual) {
          this.manualName = value.name || ''
          this.manualAddress = value.address || ''
          this.locationInput = value.latitude && value.longitude ? `${value.latitude}, ${value.longitude}` : ''
        }
      }
    }
  },

  methods: {
    ...helperMethods,
    ...mediaOwnerHelperMethods,

    restoreScreenAction: call('screens/restoreScreen'),

    statusIndicatorClass () {
      return this.statusIndicators[this.screen.status]
    },

    statusText () {
      switch (this.screen.status) {
        case 'No Issues':
          return 'Online'
        case 'Offline':
        case 'Communication Error':
          return 'Offline'
        case 'Fault':
          return 'Fault'
        default:
          return this.screen.status
      }
    },

    statusTextClass () {
      switch (this.screen.status) {
        case 'No Issues':
          return 'text-success'
        case 'Offline':
        case 'Communication Error':
          return 'text-warning'
        case 'Fault':
          return 'text-danger'
        default:
          return ''
      }
    },

    clearOperatingHours () {
      this.screenStartTime = null
      this.screenEndTime = null
    },

    async save () {
      if (this.hasPartialOperatingHours) {
        toast('Set both Screen Operating Hours fields, or clear both before saving.', 'danger')
        return
      }

      const basePayload = {
        media_owner_ids: this.stateMediaOwnerIds,
        tags: this.stateTags,
        media_owner_tags: this.stateMediaOwnerTags,
        media_owner_screen_tags: this.stateMediaOwnerScreenTags,
        has_backup_power_supplies: this.stateHasBackupPowerSupplies,
        start_time: this.screenStartTime,
        end_time: this.screenEndTime,
        timezone: this.stateTimezone,
        max_brightness: this.screenMaxBrightness
      }

      if (this.isManual) {
        const [latInput, longInput] = (this.locationInput || '').split(',').map(part => part.trim())
        const latitude = Number(latInput)
        const longitude = Number(longInput)

        Object.assign(basePayload, {
          name: this.manualName,
          address: this.manualAddress,
          latitude,
          longitude
        })
      } else {
        Object.assign(basePayload, {
          start_time: this.screenStartTime,
          end_time: this.screenEndTime
        })
      }

      if (this.$isA('admin')) {
        const adminFields = {
          screen_size: this.stateScreenSize,
          panel_type: this.statePanelType,
          pixel_pitch: this.statePixelPitch,
          native_resolution: this.stateNativeResolution,
          canvas_size: this.stateCanvasSize,
          install_date: this.stateInstallDate,
          parts_warranty_expiration: this.statePartsWarrantyExpiration,
          total_qty_module: this.stateTotalQtyModule,
          screen_width: this.stateScreenWidth,
          screen_height: this.stateScreenHeight,
          service_type: this.stateServiceType,
          psu_type: this.statePsuType,
          diode_type: this.stateDiodeType,
          device_id: this.stateDeviceId,
          screen_id: this.stateScreenId,
          panel_id: this.statePanelId,
          has_backup_power_supplies: this.stateHasBackupPowerSupplies,
          total_psu: this.screenTotalPsu,
          total_receiving_card: this.screenTotalReceivingCard,
          energy_provider_id: this.stateEnergyProvider ? this.stateEnergyProvider.id : null,
          nmi: this.stateNmi
        }

        Object.assign(basePayload, adminFields)
      }

      await this.updateScreen({
        id: this.screen.id,
        payload: basePayload
      })
      toast('Successfully updated screen', 'success')
    },

    async archiveScreen () {
      try {
        await this.deleteScreen(this.screen.id)
        toast('Screen archived', 'success')
        this.$router.push({ name: 'screens' })
      } catch (error) {
        toast('Unable to archive screen', 'danger')
        throw error
      }
    },

    async restoreScreen () {
      try {
        await this.restoreScreenAction(this.screen)
        toast('Screen restored', 'success')
        this.$router.push({ name: 'screens' })
      } catch (error) {
        toast('Unable to restore screen', 'danger')
        throw error
      }
    },

    async getMediaOwnerScreenTagData () {
      await this.getMediaOwnerScreenTagOptions()
    }
  },
  created () {
    this.getMediaOwnerScreenTagData()
  }
}
</script>

<style scoped lang="scss">
.screen-preview-stack {
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.screen-preview-image {
  display: block;
  max-width: 100%;
  height: auto;
  flex: 0 0 auto;
}

.screen-location-map-card {
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0.75rem;
  background: #f8f9fb;
  flex: 1 1 auto;
  min-height: 18rem;
}

.screen-location-map-frame {
  display: block;
  width: 100%;
  border: 0;
  height: 100%;
}
</style>
